import { Locale } from '@sheerid/jslib';


export const DEFAULT_LOCALE: Locale = 'en-US';

export const ACCEPTED_DOC_MIME_TYPES = [
    'image/png',
    'image/gif',
    'image/jpg',
    'image/jpeg',
    'image/bmp',
    'application/pdf',
];

export const MAX_DOC_UPLOAD_DOCS_ALLOWED = 3;
export const UPLOAD_FILE_PREFIX = 'file';

export const QUERY_STRING_STEP_OVERRIDE = 'mockStep';
export const QUERY_STRING_SUBSEGMENT_OVERRIDE = 'mockSubSegment';
export const QUERY_STRING_ERRORID_OVERRIDE = 'mockErrorId';

export const WSJ_EDUCATION_URL = `https://subscribe.wsj.com/SheerIDstudent/?vid=`;
